import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const ringCentral = defineConnector({
  identifier: "ringCentral",
  name: "RingCentral",
  tagLine: "Cloud communications and contact center",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () => "https://platform\\.ringcentral\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Create an app in RingCentral",
      items: [
        {
          kind: "markdown",
          content:
            "Log in to the [RingCentral Developer Portal](https://developers.ringcentral.com/) and go to **Console → Apps**. Create a new app with **REST API** access, then copy the client ID and client secret.",
        },
        {
          kind: "input",
          label: "Client ID",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
        },
        {
          kind: "input",
          label: "Client secret",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
    {
      title: "Connect your account",
      items: [
        {
          kind: "oauth",
          dependsOn: [
            { kind: "oauthConnection", field: "clientId" },
            { kind: "oauthConnection", field: "clientSecret" },
          ],
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () =>
      "https://platform.ringcentral.com/restapi/oauth/authorize",
    tokenEndpoint: () => "https://platform.ringcentral.com/restapi/oauth/token",
    clientCredentialsFrom: "db",
    tokenEndpointAuthMethod: () => "client_secret_basic",
    scopes: () => [],
  },
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: "https://platform.ringcentral.com/restapi/v1.0/account/~/extension/~",
      expectedStatus: [200, 403],
    }),
  },
});
